import { useMemo } from 'react'

import { useLaunchDarkly } from '@navinc/base-react-components'

import * as booleanFeatureFlags from '../../common/boolean-flags.js'
import * as variantFeatureFlags from '../../common/variant-flags.js'

/** useIsFeatureFlagOn returns the result for boolean-type feature flags */
export const useIsFeatureFlagOn = (featureFlag, defaultValue = false) => {
  const { whichVariation } = useLaunchDarkly()
  return !!(whichVariation?.(featureFlag, defaultValue) ?? defaultValue)
}

/** useFeatureFlagVariant returns the result for non-boolean-type feature flags, like string, number, or JSON flag types */
export const useFeatureFlagVariant = (featureFlag, defaultValue) => {
  const { whichVariation } = useLaunchDarkly()
  return whichVariation?.(featureFlag, defaultValue) ?? defaultValue
}

export const useAllBooleanFeatureFlags = () => {
  const { whichVariation } = useLaunchDarkly()
  return useMemo(
    () =>
      Object.fromEntries(
        Object.entries(booleanFeatureFlags).map(([_key, value]) => [value, !!(whichVariation?.(value, false) ?? false)])
      ),
    [whichVariation]
  )
}

export const useAllVariantFeatureFlags = () => {
  const { whichVariation } = useLaunchDarkly()
  return useMemo(
    () =>
      Object.fromEntries(
        Object.entries(variantFeatureFlags).map(([_key, value]) => [value, whichVariation?.(value, null) ?? null])
      ),
    [whichVariation]
  )
}

export const useAllFeatureFlags = () => {
  const allBooleanFeatureFlags = useAllBooleanFeatureFlags()
  const allVariantFeatureFlags = useAllVariantFeatureFlags()
  return useMemo(
    () => Object.assign({}, allBooleanFeatureFlags, allVariantFeatureFlags),
    [allBooleanFeatureFlags, allVariantFeatureFlags]
  )
}
